import emailjs from '@emailjs/browser';

export class Email {
  static initializeService() {
    const key = import.meta.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    emailjs.init({
      publicKey: key,
      blockHeadless: true,
      blockList: {
        list: [],
        watchVariable: 'email',
      },
      limitRate: {
        id: 'app',
        throttle: 1000
      },
    });
  };

  static sendPaymentErrorsEmail(client, instance, emails, paymentErrors) {
    if (!client || !instance || !emails || emails.length === 0 || !paymentErrors || paymentErrors.length === 0) return Promise.resolve({ status: false, response: null, error: 'Missing parameters' });
    const errorsHtml = paymentErrors.map((error) => `<li>${error.datetime}: [${error.type}] ${error.message}</li>`).join('');
    this.initializeService();
    const parameters = {
      client: client,
      instance: instance,
      emails: emails.join(', '),
      paymentErrors: `<ol>${errorsHtml}</ol>`
    };
    return emailjs.send('gmail', 'template_focud96', parameters)
      .then(
        (response) => {
          return { status: true, response: response, error: null };
        },
        (error) => {
          return { status: false, response: null, error: error };
        },
      );
  };
}